import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const CLU_DOCREGLEMENT_SCHEMA_LITERAL = {
    title: 'Schéma LigneDocument',
    description: 'Document',
    version: 2,
    keyCompression: false,
    primaryKey: 'PK_ID',
    type: 'object',
    properties: {
        PK_ID : { type : 'string', maxLength : 100 },
        MD_SITEGID : { type : 'string' },
        MD_SITE : { type : 'string' },
        MD_DATE_CREATION : { type : 'string' },
        USER_ID: { type: 'string' },
        MD_CBMARQ : { type : 'number' },
        RG_NO_INTERNAL : { type : 'number' },
        DO_PIECE : { type : 'string' },
        DO_PIECE_INTERNAL : { type : 'string' },
        RG_DATE : { type : 'string' },
        N_REGLEMENT_MODE : { type : 'string', default : 0 },
        N_REGLEMENT : { type : 'string' },
        N_REGLEMENTLIB : { type : 'string' },
        RG_MONTANT : { type : 'number', default : 0 },
        RG_PROV : { type : 'number', default : 0 },
        N_DEVISE_ENABLE : { type : 'boolean' },
        N_DEVISE : { type : 'number', default : 0 },
        N_DEVISE_LIB : { type : ['string', 'null'] },
        RG_MONTANTDEV : { type : 'number', default : 0 },
        RG_COURS : { type : 'number', default : 0 },
        RG_REFERENCE : { type : ['string', 'null'] },
        RG_PIECE : { type : ['string', 'null'] },
        JO_NUM : { type : ['string', 'null'] },
        RG_LIBELLE : { type : ['string', 'null'] },
        RG_TYPEREG : { type : 'number', default : 0 },
        DO_PIECEACOMPTE: { type: ['string', 'null'], default : '' }
    },
    required: [ 'RG_NO_INTERNAL', 'RG_DATE', 'MD_CBMARQ', 'RG_MONTANT' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(CLU_DOCREGLEMENT_SCHEMA_LITERAL);
export type RxCluDocReglementDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const CLU_DOCREGLEMENT_SCHEMA: RxJsonSchema<RxCluDocReglementDocumentType> = CLU_DOCREGLEMENT_SCHEMA_LITERAL;
